import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IGetFiltersResponseV2Schema } from '../../common/repositories/job-vacancies-backend/entities/filters/GetFiltersResponseV2Schema';
import { ISetSelectedFilters } from '../../types/filters';
import { IDepartamentGroupSchema } from '../../common/repositories/job-vacancies-backend/entities/vacancies_listing/DepartamentGroupSchema';
import { IRetrieveVacancyResponseV2 } from '../../common/repositories/job-vacancies-backend/entities/vacancies/RetrieveVacancyResponseV2';

export enum EVacanciesActionTypes {
  SetVacanciesGroups = 'VACANCIES/SET_VACANCIES_GROUPS',
  SetVacancy = 'VACANCIES/SET_VACANCY',
  RequestVacancies = 'VACANCIES/REQUEST_VACANCIES',
  RequestVacanciesError = 'VACANCIES/REQUEST_VACANCIES_ERROR',
  SetFilters = 'VACANCIES/SET_FILTERS',
  SetSelectedFilters = 'VACANCIES/SET_SELECTED_FILTERS',
  SetTags = 'VACANCIES/SET_TAGS',
  ResetFilters = 'VACANCIES/RESET_FILTER',
}

export type TSetVacanciesGroups = ITypedReduxAction<
  EVacanciesActionTypes.SetVacanciesGroups,
  IDepartamentGroupSchema[]
>;
export type TSetFilters = ITypedReduxAction<EVacanciesActionTypes.SetFilters, IGetFiltersResponseV2Schema>;
export type TResetFilters = ITypedReduxAction<EVacanciesActionTypes.ResetFilters, string>;
export type TSetTags = ITypedReduxAction<EVacanciesActionTypes.SetTags, string[]>;
export type TSetSelectedFilters = ITypedReduxAction<EVacanciesActionTypes.SetSelectedFilters, ISetSelectedFilters>;
export type TSetVacancy = ITypedReduxAction<EVacanciesActionTypes.SetVacancy, IRetrieveVacancyResponseV2>;
export type TRequestVacancies = ITypedReduxAction<EVacanciesActionTypes.RequestVacancies>;
export type TRequestVacanciesError = ITypedReduxAction<EVacanciesActionTypes.RequestVacanciesError>;

export const setVacanciesGroups: (groups: IDepartamentGroupSchema[]) => TSetVacanciesGroups = actionGenerator<
  EVacanciesActionTypes.SetVacanciesGroups,
  IDepartamentGroupSchema[]
>(EVacanciesActionTypes.SetVacanciesGroups);

export const setFilters: (filters: IGetFiltersResponseV2Schema) => TSetFilters = actionGenerator<
  EVacanciesActionTypes.SetFilters,
  IGetFiltersResponseV2Schema
>(EVacanciesActionTypes.SetFilters);

export const resetFilters: (filterName?: string) => TResetFilters = actionGenerator<
  EVacanciesActionTypes.ResetFilters,
  string
>(EVacanciesActionTypes.ResetFilters);

export const setSelectedFilters: (options: ISetSelectedFilters) => TSetSelectedFilters = actionGenerator<
  EVacanciesActionTypes.SetSelectedFilters,
  ISetSelectedFilters
>(EVacanciesActionTypes.SetSelectedFilters);

export const setVacancy: (vacancies: IRetrieveVacancyResponseV2) => TSetVacancy = actionGenerator<
  EVacanciesActionTypes.SetVacancy,
  IRetrieveVacancyResponseV2
>(EVacanciesActionTypes.SetVacancy);

export const requestVacancies: () => TRequestVacancies = actionGenerator<EVacanciesActionTypes.RequestVacancies>(
  EVacanciesActionTypes.RequestVacancies,
);

export const requestVacanciesError: () => TRequestVacanciesError =
  actionGenerator<EVacanciesActionTypes.RequestVacanciesError>(EVacanciesActionTypes.RequestVacanciesError);

export type TVacanciesActions =
  | TSetVacancy
  | TRequestVacancies
  | TRequestVacanciesError
  | TSetFilters
  | TResetFilters
  | TSetSelectedFilters
  | TSetVacanciesGroups
  | TSetTags;
